import { render } from "./OrderCustomFieldsCreatePage.vue?vue&type=template&id=da4ff8f8"
import script from "./OrderCustomFieldsCreatePage.vue?vue&type=script&lang=js"
export * from "./OrderCustomFieldsCreatePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__